import { InfoBar } from '@2n/design-system';
import * as React from 'react';

export interface IErrorBarData {
  title?: string;
  children: React.ReactNode;
}

export function FilledErrorBar(data: IErrorBarData) {
  return (
    <InfoBar
      variant="standard"
      type="error"
      title={data.title || undefined}
      sx={{
        backgroundColor: 'error.alert.background',
        color: 'error.text',
      }}
    >
      {data.children}
    </InfoBar>
  );
}
